import { LineasAsientosContablesByFilterDtoIProps } from "api/DTOs/LineasAsientosContablesByFilterDto"
import { TIPO_LINEA_ASIENTO } from "api/Types/TipoLineaAsiento"
import { TFunction } from "i18next"
import { frontendDateFormat } from "utils/formatDate"
import { ColoredNumber } from "../../../components/ColoredNumber"
import { NeutralNumber } from "../../../components/NeutralNumber"
import { TIPOS_ASIENTOS } from "./TiposAsientos"
import {
  DocumentoAsociadoAsiento,
  NombreCuentaContableAsiento,
} from "./columnsTemplates"

export const LIBRO_MAYOR_COLUMNS = (
  t: TFunction,
  handleOpenDocumentoModal: (id: string) => void
) => {
  const columns = [
    {
      header: t("diario.tab.headerEntry"),
      field: "asientoContable.numero",
      key: "asientoContable.numero",
      style: { width: "5%" },
      sortable: true,
      sortField: "asientoContable.numero",
    },
    {
      header: t("diario.tab.headerLine"),
      field: "numero",
      key: "numero",
      style: { width: "5%" },
      sortable: true,
      sortField: "numero",
    },
    {
      header: t("diario.tab.headerDate"),
      field: "asientoContable.fecha",
      key: "asientoContable.fecha",
      style: { width: "5%" },
      sortable: true,
      sortField: "asientoContable.fecha",
      body: ({ asientoContable }: LineasAsientosContablesByFilterDtoIProps) => {
        return asientoContable?.fecha
          ? frontendDateFormat(new Date(asientoContable.fecha))
          : ""
      },
    },
    {
      header: t("diario.tab.headerType"),
      field: "asientoContable.tipo",
      key: "asientoContable.tipo",
      style: { width: "8%" },
      sortable: true,
      sortField: "asientoContable.tipoAsiento",
      body: (rowData: LineasAsientosContablesByFilterDtoIProps) =>
        TIPOS_ASIENTOS(t).find(
          ({ tipo }) => rowData?.asientoContable?.tipo === tipo
        )?.descripcion,
    },
    {
      header: t("diario.tab.headerDescription"),
      field: "descripcion",
      key: "descripcion",
      style: { width: "19%" },
      sortable: true,
      sortField: "descripcion",
    },
    {
      header: t("diario.tab.headerDoc"),
      field: "numeroDocumento",
      key: "numeroDocumento",
      style: { width: "10%" },
      sortable: true,
      sortField: "numeroDocumento",
      body: (rowData: LineasAsientosContablesByFilterDtoIProps) =>
        DocumentoAsociadoAsiento({ handleOpenDocumentoModal, rowData }),
    },
    {
      header: t("diario.tab.headerAccount"),
      field: "cuentaContable.numero",
      key: "cuentaContable.numero",
      style: { width: "8%" },
      sortable: false,
      sortField: "numeroCuentaContable",
      body: (rowData: LineasAsientosContablesByFilterDtoIProps) =>
        NombreCuentaContableAsiento({
          rowData: { numeroCuentaContable: rowData?.cuentaContable?.numero },
        }),
    },
    {
      header: t("diario.tab.headerName"),
      field: "cuentaContable.nombre",
      key: "cuentaContable.nombre",
      style: { width: "17%" },
    },
    {
      header: t("diario.tab.headerDebit"),
      field: "debe",
      key: "debe",
      style: { width: "6%" },
      className: "!tw-text-end",
      sortable: false,
      sortField: "debe",
      body: (rowData: LineasAsientosContablesByFilterDtoIProps) => {
        const debe =
          rowData?.tipo === TIPO_LINEA_ASIENTO.DEBE ? rowData?.importe ?? 0 : 0
        return NeutralNumber(debe)
      },
    },
    {
      header: t("diario.tab.headerHaber"),
      field: "haber",
      key: "haber",
      style: { width: "6%" },
      className: "!tw-text-end",
      sortable: false,
      sortField: "haber",
      body: (rowData: LineasAsientosContablesByFilterDtoIProps) => {
        const haber =
          rowData?.tipo === TIPO_LINEA_ASIENTO.HABER ? rowData?.importe ?? 0 : 0
        return NeutralNumber(haber)
      },
    },
    {
      header: t("diario.tab.headerCredit"),
      field: "saldo",
      key: "saldo",
      style: { width: "6%" },
      className: "!tw-text-end",
      sortable: true,
      sortField: "saldo",
      body: (rowData: LineasAsientosContablesByFilterDtoIProps) => {
        return ColoredNumber(rowData?.saldo ?? 0)
      },
    },
  ]
  return columns
}
